import * as React from "react";
import PropTypes from "prop-types";
import some from "lodash-es/some";
import useAsyncEffect from "@n1ru4l/use-async-effect";

import "./styles.css";
import { getExperiences } from "../../model/experiences";
import { connectToProps } from "../../model/utils";
import { fieldChanged } from "../../store/actions";
import SingleExperience from "./single-experience";

const mapDispatchToProps = dispatch => ({
  fieldChanged: fieldName => dispatch(fieldChanged(fieldName))
});

const ExperienceSelector = ({
  fieldName,
  fieldChanged,
  selectedExperiences,
  setSelectedExperiences
}) => {
  const [experiences, setExperiences] = React.useState(null);

  const hasExperience = React.useCallback(
    e => some(selectedExperiences || [], experience => e.id === experience.id),
    [selectedExperiences]
  );

  const toggleExperience = React.useCallback(
    e => {
      setSelectedExperiences(
        hasExperience(e)
          ? selectedExperiences.filter(experience => experience.id !== e.id)
          : (selectedExperiences || []).concat([e])
      );
      if (fieldName) {
        fieldChanged(fieldName);
      }
    },
    [
      fieldChanged,
      fieldName,
      hasExperience,
      selectedExperiences,
      setSelectedExperiences
    ]
  );

  useAsyncEffect(function*() {
    const es = yield getExperiences();
    setExperiences(es);
  }, []);

  return experiences === null ? (
    <div>Loading...</div>
  ) : (
    <>
      <div className="row">
        {experiences.map(e => (
          <SingleExperience
            key={e.id}
            experience={e}
            hasExperience={hasExperience}
            toggleExperience={toggleExperience}
          />
        ))}
      </div>
    </>
  );
};

ExperienceSelector.propTypes = {
  fieldName: PropTypes.string,
  fieldChanged: PropTypes.func.isRequired,
  selectedExperiences: PropTypes.arrayOf(PropTypes.object),
  setSelectedExperiences: PropTypes.func
};

export default connectToProps(
  ["selectedExperiences"],
  () => ({}),
  mapDispatchToProps
)(ExperienceSelector);
